<template>
	<div
		class="component c-podcasts padding-y-24 bp-768:padding-y-48"
		:class="{ dark: section.dark_mode }"
		v-bind:style="{
			'background-image': 'url(' + section.backgroundImage + ') ',
		}"
	>
		<div class=" row padding-x-12">
			<common-header
				:headline="section.headline"
				:sponsor="section.sponsor"
			/>
		</div>
		<div class=" row padding-x-12">
			<div class="c-podcast__player">
				<vue-plyr ref="plyr">
					<audio controls crossorigin playsinline>
						<source
							:src="selected_audio_file.pod_absolute_url"
							:type="selected_audio_file.pod_enclosure_type"
						/>
					</audio>
				</vue-plyr>
			</div>
		</div>
		<div class=" row padding-x-12">
			<div
				v-if="section.podcasts && template.name === 'Podcasts-1'"
				class=" flex-item-1 c-podcasts__list c-podcasts__template-1"
			>
				<ul class="reset-list">
					<li
						class="c-podcast__item"
						v-for="podcast in section.podcasts.slice(0, 5)"
						:key="podcast.pod_id"
						v-on:click="play_podcast(podcast)"
					>
						<div
							class="c-podcast__image"
							v-bind:style="{
								'background-image':
									'url(' +
									podcast.image_file_path +
									'?width=768) ',
							}"
						></div>
						<div class="c-podcast__content">
							<div
								class="c-podcast__date"
								v-if="podcast.pod_pubdate"
							>
								Published On:
								{{
									podcast.pod_pubdate
										? moment(podcast.pod_pubdate).format(
												'MMMM DD, YYYY',
										  )
										: 'N/A'
								}}
							</div>
							<div
								class="c-podcast__title"
								v-html="podcast.pod_title"
							></div>
							<div
								class="c-podcast__description"
								v-html="podcast.pod_description"
							></div>
						</div>
						<div class="c-podcast__listen-wrapper">
							<button type="button" class="c-podcast__listen">
								<div class="c-podcast__listen-icon">
									<feather
										v-if="
											player &&
												parseInt(
													selected_audio_file.pod_id,
												) != parseInt(podcast.pod_id)
										"
										class="line-height-1 c-navigation__url-icon"
										size="24"
										stroke-width="1"
										type="volume-2"
									></feather>
									<feather
										v-if="
											player &&
												player_event &&
												parseInt(
													selected_audio_file.pod_id,
												) == parseInt(podcast.pod_id)
										"
										class="line-height-1 c-navigation__url-icon"
										size="24"
										stroke-width="1"
										type="pause"
									></feather>
									<feather
										v-if="
											player &&
												!player_event &&
												parseInt(
													selected_audio_file.pod_id,
												) == parseInt(podcast.pod_id)
										"
										class="line-height-1 c-navigation__url-icon"
										size="24"
										stroke-width="1"
										type="play"
									></feather>
								</div>
								<span>Listen</span>
							</button>
						</div>
					</li>
				</ul>
			</div>
			<div
				v-if="section.podcasts && template.name === 'Podcasts-2'"
				class=" flex-item-1 c-podcasts__list c-podcasts__template-2"
			>
				<ul class="reset-list bp-1024:d-flex flex-wrap-wrap">
					<li
						class="c-podcast__item align-items-center flex-wrap-wrap bp-1024:align-items-flex-start bp-540:d-flex bp-1024:d-block"
						v-for="podcast in section.podcasts.slice(0, 4)"
						:key="podcast.pod_id"
						v-on:click="play_podcast(podcast)"
					>
						<div
							class="c-podcast__image"
							v-bind:style="{
								'background-image':
									'url(' +
									podcast.image_file_path +
									'?width=768) ',
							}"
						></div>
						<div class="c-podcast__content">
							<div
								class="c-podcast__date"
								v-if="podcast.pod_pubdate"
							>
								Published On:
								{{
									podcast.pod_pubdate
										? moment(podcast.pod_pubdate).format(
												'MMMM DD, YYYY',
										  )
										: 'N/A'
								}}
							</div>
							<div
								class="c-podcast__title font-size-16 bp-1280:font-size-21 line-height-125"
								v-html="podcast.pod_title"
							></div>
							<div
								class="c-podcast__description font-size-14 bp-1280:font-size-16 line-height-175"
								v-html="podcast.pod_description"
							></div>
						</div>
						<div class="c-podcast__listen-wrapper">
							<button type="button" class="c-podcast__listen">
								<div class="c-podcast__listen-icon">
									<feather
										v-if="
											player &&
												parseInt(
													selected_audio_file.pod_id,
												) != parseInt(podcast.pod_id)
										"
										class="line-height-1 c-navigation__url-icon"
										size="24"
										stroke-width="1"
										type="volume-2"
									></feather>
									<feather
										v-if="
											player &&
												player_event &&
												parseInt(
													selected_audio_file.pod_id,
												) == parseInt(podcast.pod_id)
										"
										class="line-height-1 c-navigation__url-icon"
										size="24"
										stroke-width="1"
										type="pause"
									></feather>
									<feather
										v-if="
											player &&
												!player_event &&
												parseInt(
													selected_audio_file.pod_id,
												) == parseInt(podcast.pod_id)
										"
										class="line-height-1 c-navigation__url-icon"
										size="24"
										stroke-width="1"
										type="play"
									></feather>
								</div>
								<span>Listen</span>
							</button>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="row padding-x-24 margin-t-12">
			<a
				class="s-common__button c-stories__more font-size-14 line-height-125 font-weight-700"
				:href="'/podcasts?path=' + $root.signing_day.sport.shortname"
				>View All Podcasts</a
			>
		</div>
	</div>
</template>

<script>
import SectionBase from './SectionBase';
import CommonHeader from '@/components/common/CommonHeader.vue';
export default {
	extends: SectionBase,
	name: 'SectionPodcasts',
	components: { CommonHeader },
	data: () => ({
		podcasts: [],
		selected_audio_file: null,
		player: null,
		player_event: false,
	}),
	methods: {
		play_podcast(podcast) {
			if (
				parseInt(this.selected_audio_file.pod_id) !=
				parseInt(podcast.pod_id)
			) {
				this.selected_audio_file = podcast;
				this.player.source = {
					type: 'audio',
					title: this.selected_audio_file.pod_title,
					sources: [
						{
							src: this.selected_audio_file.pod_absolute_url,
							type: this.selected_audio_file.pod_enclosure_type,
						},
					],
				};
			}
			if (
				parseInt(this.selected_audio_file.pod_id) !=
				parseInt(podcast.pod_id)
			) {
				this.player.play();
			} else {
				if (!this.player.playing) {
					this.player.play();
				} else {
					this.player.pause();
				}
			}
		},
	},
	created() {
		this.selected_audio_file = this.section.podcasts[0];
	},
	mounted() {
		this.player = this.$refs.plyr.player;
		this.player.on('pause', () => (this.player_event = false));
		this.player.on('play', () => (this.player_event = true));
	},
};
</script>

<style lang="scss">
.plyr--audio {
	.plyr {
		&__controls {
			width: 100%;
			border-radius: 50px !important;
			padding: 0 8px;
			border: 1px solid #dfdfdf;
		}
	}
}

:root {
	--plyr-color-main: var(--color-primary);
	--plyr-audio-control-color-hover: var(--text-on-primary);
}
[data-theme='dark'],
.dark {
	:root {
		--plyr-audio-controls-background: var(--main-color-alt);
	}
}
</style>
<style scoped lang="scss">
.c-podcast {
	&__player {
		width: 100%;
		margin: 24px 0;
	}
}
.c-podcasts__template-1 {
	.c-podcast {
		&__item {
			color: $main-font-color;
			background: $main-color;
			border: 1px solid $main-border-color;
			box-sizing: border-box;
			border-radius: 10px;
			overflow: hidden;
			margin: 0 0 12px 0;
			padding: 24px;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			@media screen and (min-width: 1024px) {
			}
		}
		&__date {
			font-size: 0.75rem;
			line-height: 150%;
		}
		&__image {
			width: 100%;
			padding-bottom: 100%;
			background-size: cover;
			border-radius: 10px;
			overflow: hidden;
			background-position: top center;
			@media screen and (min-width: 541px) {
				width: 60px;
				height: 60px;
				padding-bottom: 0;
				align-self: flex-start;
			}
			@media screen and (min-width: 1024px) {
				height: 200px;
				width: 200px;
				align-self: flex-center;
			}
		}
		&__content {
			padding: 0 24px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			flex: 1;
			@media screen and (max-width: 540px) {
				padding: 24px 0 0 0;
			}
		}
		&__title {
			font-size: 1.313rem;
			line-height: 125%;
			font-weight: bold;
			margin: 18px 0;
		}
		&__description {
			font-weight: normal;
			font-size: 1rem;
			line-height: 175%;
		}
		&__listen {
			width: 150px;
			height: 48px;
			border: 1px solid $main-border-color;
			background: $main-gray-color;
			color: $main-font-color;
			border-radius: 50px;
			font-weight: bold;
			font-size: 0.875rem;
			line-height: 125%;
			position: relative;
			padding-left: 48px;
			text-align: left;
			cursor: pointer;
			> span {
				margin-left: 24px;
			}
			&-icon {
				border: 1px solid $main-border-color;
				width: 48px;
				height: 48px;
				border-radius: 50px;
				background: $color-primary;
				color: var(--text-on-primary);
				position: absolute;
				left: -1px;
				top: -1px;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: 0.25s;
			}
			&:hover {
				.c-podcast__listen {
					&-icon {
						transition: 0.25s;
						filter: brightness(80%);
					}
				}
			}
			&-wrapper {
				@media screen and (max-width: 768px) {
					width: 100%;
					margin-top: 24px;
				}
			}
		}
	}
}
.c-podcasts__template-2 {
	.c-podcast {
		&__list {
			margin: 0 -6px;
		}
		&__date {
			font-size: 0.75rem;
			line-height: 150%;
		}
		&__item {
			color: $main-font-color;
			background: $main-color;
			border: 1px solid $main-border-color;
			box-sizing: border-box;
			border-radius: 10px;
			overflow: hidden;
			margin: 0 0 12px 0;
			padding: 24px;
			flex: 0 0 25%;
			margin: 0 6px 12px 6px;
		}
		&__image {
			width: 100%;
			height: 200px;
			padding-bottom: 100%;
			background-size: cover;
			border-radius: 10px;
			overflow: hidden;
			align-self: flex-start;
			background-position: top center;
			@media screen and (min-width: 540px) {
				width: 80px;
				height: 80px;
				padding: 0;
			}
			@media screen and (min-width: 768px) {
				width: 200px;
				height: 200px;
				padding: 0;
				align-self: center;
			}
			@media screen and (min-width: 1024px) {
				width: 100%;
				height: 200px;
				padding-bottom: 100%;
			}
		}
		&__content {
			padding: 24px 0 0 0;
			display: flex;
			flex-direction: column;
			justify-content: center;
			flex: 1;
			@media screen and (min-width: 540px) {
				padding: 0 24px;
			}
			@media screen and (min-width: 1024px) {
				padding: 24px 0 0 0;
			}
		}
		&__title {
			font-weight: bold;
			margin: 18px 0;
		}
		&__description {
			font-weight: normal;
		}
		&__listen {
			width: 150px;
			height: 48px;
			border: 1px solid $main-border-color;
			background: $main-gray-color;
			color: $main-font-color;
			border-radius: 50px;
			font-weight: bold;
			font-size: 0.875rem;
			line-height: 125%;
			position: relative;
			padding-left: 48px;
			text-align: left;
			cursor: pointer;
			> span {
				margin-left: 24px;
			}
			&-icon {
				border: 1px solid $main-border-color;
				width: 48px;
				height: 48px;
				border-radius: 50px;
				background: $color-primary;
				color: var(--text-on-primary);
				position: absolute;
				left: -1px;
				top: -1px;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: 0.25s;
			}
			&:hover {
				.c-podcast__listen {
					&-icon {
						transition: 0.25s;
						filter: brightness(80%);
					}
				}
			}
			&-wrapper {
				width: 100%;
				display: flex;
				margin: 24px 0 0 0;
				@media screen and (min-width: 768px) {
					width: auto;
				}
				@media screen and (min-width: 1024px) {
					width: 100%;
					justify-content: center;
				}
			}
			@media screen and (min-width: 768px) {
				flex: 1;
			}
			@media screen and (min-width: 1024px) {
				flex: 0 0 auto;
			}
		}
	}
}
</style>
